import { useState, useEffect, useCallback } from 'react';
var API = 'https://api.algrok.com';

var SOURCE_MAP={autodn:{l:'Auto DN',c:'#0ea5e9'},amb:{l:'AMB',c:'#f97316'},straddle:{l:'Straddle',c:'#ec4899'},positional_tv:{l:'JP Signal',c:'#a78bfa'},quantiply:{l:'Quantiply',c:'#fbbf24'}};

export default function OrdersM(){
  var [orders,setOrders]=useState([]);
  var [filter,setFilter]=useState('ALL');

  var fetchOrders=useCallback(function(){
    fetch(API+'/orders').then(function(r){return r.json();}).then(function(d){
      setOrders(Array.isArray(d)?d:(d.data||[]));
    }).catch(function(){});
  },[]);
  useEffect(function(){fetchOrders();var id=setInterval(fetchOrders,10000);return function(){clearInterval(id);};},[fetchOrders]);

  var G='#00d4aa',R='#ff4466',Y='#fbbf24',M='#4a5c72',T='#e2e8f0',BD='rgba(26,45,74,0.35)',CD='rgba(12,18,32,0.95)';

  var filtered=filter==='ALL'?orders:orders.filter(function(o){return o.status===filter;});
  var completed=orders.filter(function(o){return o.status==='COMPLETE';}).length;
  var open=orders.filter(function(o){return['OPEN','AMO REQ RECEIVED','TRIGGER PENDING'].indexOf(o.status)>=0;}).length;

  return(
  <div style={{minHeight:'100vh',background:'#05080f',color:T,fontFamily:"system-ui,sans-serif",paddingTop:'env(safe-area-inset-top,0)',paddingBottom:70,overflowX:'hidden'}}>
    {/* Header */}
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 16px 10px',borderBottom:'1px solid '+BD}}>
      <span style={{fontSize:15,fontWeight:800}}>Orders</span>
      <div style={{display:'flex',gap:8}}>
        <span style={{fontSize:10,color:G}}>{completed} filled</span>
        <span style={{fontSize:10,color:Y}}>{open} open</span>
      </div>
    </div>

    {/* Filters */}
    <div style={{display:'flex',gap:6,padding:'10px 12px',overflowX:'auto'}}>
      {['ALL','COMPLETE','OPEN','REJECTED','CANCELLED'].map(function(f){
        var active=filter===f;
        return<div key={f} onClick={function(){setFilter(f);}} style={{padding:'6px 12px',borderRadius:20,fontSize:10,fontWeight:700,whiteSpace:'nowrap',color:active?T:M,background:active?'rgba(14,165,233,0.15)':'rgba(0,0,0,0.2)',border:'1px solid '+(active?'rgba(14,165,233,0.3)':BD)}}>{f}</div>;
      })}
    </div>

    {/* Order Cards */}
    <div style={{padding:'0 12px'}}>
      {filtered.length===0&&<div style={{textAlign:'center',color:M,padding:40,fontSize:12}}>No orders</div>}
      {filtered.map(function(o,i){
        var tag=(o.tag||'').toLowerCase();
        var src=SOURCE_MAP[tag]||(tag.startsWith('qty_')?{l:'Qty '+tag.slice(4).toUpperCase(),c:'#fbbf24'}:null);
        var isBuy=o.transaction_type==='BUY';
        var sc=o.status==='COMPLETE'?G:o.status==='REJECTED'||o.status==='CANCELLED'?R:['OPEN','TRIGGER PENDING'].indexOf(o.status)>=0?Y:M;
        var price=o.average_price>0?o.average_price:o.price||0;

        return<div key={o.order_id||i} style={{background:CD,borderRadius:12,border:'1px solid '+BD,padding:'10px 14px',marginBottom:6}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
            <div style={{display:'flex',alignItems:'center',gap:6}}>
              <span style={{padding:'2px 6px',borderRadius:4,fontSize:9,fontWeight:800,color:isBuy?G:R,background:(isBuy?G:R)+'15'}}>{isBuy?'\u25B2 BUY':'\u25BC SELL'}</span>
              <span style={{fontSize:12,fontWeight:800}}>{o.tradingsymbol}</span>
            </div>
            <span style={{padding:'2px 8px',borderRadius:4,fontSize:8,fontWeight:800,color:sc,background:sc+'15'}}>{o.status}</span>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:8}}>
            <div style={{display:'flex',gap:10,fontSize:10,color:M}}>
              <span>Qty: {o.quantity}</span>
              <span>\u20B9{price.toFixed(1)}</span>
              <span>{o.product}</span>
            </div>
            {src?<span style={{padding:'2px 6px',borderRadius:4,fontSize:8,fontWeight:800,color:src.c,background:src.c+'15'}}>{src.l}</span>
            :<span style={{fontSize:8,color:M}}>Manual</span>}
          </div>
          <div style={{fontSize:9,color:M,marginTop:4}}>
            {o.order_timestamp?new Date(o.order_timestamp).toLocaleTimeString('en-IN'):'--'}
          </div>
        </div>;
      })}
    </div>
  </div>);
}
